"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _type = require("./type.js");
// @ts-check

/**
 * @param {SimplePosType} domInfo
 * @param {SimplePosType} scrollInfo 
 * @returns {boolean}
 */
var isFullOnScreen = function isFullOnScreen(domInfo, scrollInfo) {
  var bool = domInfo.top > scrollInfo.top && domInfo.right < scrollInfo.right && domInfo.bottom < scrollInfo.bottom && domInfo.left > scrollInfo.left;
  return bool;
};
var _default = exports["default"] = isFullOnScreen;
module.exports = exports.default;